import { createSelector } from 'reselect';
import { getMachine } from 'lib/selectors/getMachine';
import _get from 'lodash/get';

/**
 * Selector that determines if a machine is mapped to ERP resources.
 *
 * A machine is considered mapped to ERP when it has either:
 * - A direct erpResourceId assigned to the machine
 * - Associated ERP resources from machine groups (erpResources array)
 *
 * This mapping is required for ERP-driven workflows like work orders and labor tracking.
 */
const getIsMachineMappedToErp = createSelector([getMachine], (machine) => {
  const erpResourceId = _get(machine, 'erpResourceId');
  const erpAssociatedResources = _get(machine, 'erpResources');

  return !!(erpResourceId || erpAssociatedResources?.length);
});

export { getIsMachineMappedToErp };
